import {
  CriteriaWithPagination,
  EuiBasicTable,
  EuiBasicTableColumn,
  EuiButtonIcon,
  EuiComboBox,
  EuiFlexGroup,
  EuiFlexItem,
  EuiFormRow,
  EuiHealth,
  EuiLink,
  EuiSpacer,
  EuiTableSelectionType,
  Pagination,
  euiPaletteColorBlindBehindText,
} from "@elastic/eui";
import {
  Box,
  Divider,
  List,
  Menu,
  NumberFormatter,
  Text,
  Title,
} from "@mantine/core";
import { modals } from "@mantine/modals";
import { useState } from "react";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import {
  isNullOrEmpty,
  isNullOrUndefined,
  isNullOrUndefinedArry,
} from "../../../_base/extension/StringExtension";
import Repository from "../../../_base/helper/HttpHelper";
import { paginationBase } from "../../../_base/model/_base/BaseTable";
import { ParamSearchBase } from "../../../_base/model/_base/ParamSearchBase";
import AppAction from "../../../common/AppAction";
import AppSearch from "../../../common/AppSearch";
import { API_ROUTE } from "../../../const/apiRoute";
import { MessageResponse } from "../../../model/MessageResponse";
import CreateView from "./CreateView";
import DeleteView from "./DeleteView";
import EditView from "./EditView";
import { useNavigate } from "react-router-dom";
import { WarranteeSamsungSession } from "../../../model/TblWarranteeSamsung";
import { excuteWarranteeSamsungSession } from "../../../api/ApiWarranteeSamsung";

const visColorsBehindText = euiPaletteColorBlindBehindText();

const optionSearch = {
  isActive: [
    {
      value: true,
      label: "Kích hoạt",
      "data-test-subj": "titanOption",
      color: visColorsBehindText[0],
    },
    {
      value: false,
      label: "Chưa kích hoạt",
      color: visColorsBehindText[1],
    },
  ],

  status: [
    {
      value: "N",
      label: "New",
      "data-test-subj": "titanOption",
      color: visColorsBehindText[0],
    },
    {
      value: "R",
      label: "Running",
      "data-test-subj": "titanOption",
      color: visColorsBehindText[0],
    },
    {
      value: "S",
      label: "Success",
      "data-test-subj": "titanOption",
      color: visColorsBehindText[0],
    },
  ],
};

const WarranteeSamsungSessionList = () => {
  const navigate = useNavigate();
  const columns: Array<EuiBasicTableColumn<any>> = [
    {
      field: "id",
      name: "ID",
      sortable: true,
      truncateText: true,
      width: "3%",
    },
    {
      field: "name",
      name: "Tên phiên",
      sortable: true,
      width: "22%",
      truncateText: true,
      render: (name: string, online: WarranteeSamsungSession) => (
        <EuiLink
          target="_blank"
          onClick={(e: any) => {
            handleEditData(online.id);
          }}
        >
          {name}
        </EuiLink>
      ),
    },
    {
      field: "status",
      name: "Trạng thái",
      sortable: true,
      truncateText: true,
      render: (status: string, collection: WarranteeSamsungSession) => (
        <EuiHealth color={getStatusColor(status)}>
          {status === "N"
            ? "New"
            : status === "R"
            ? "Running"
            : status === "S"
            ? "Success"
            : "Chờ duyệt"}
        </EuiHealth>
      ),
    },
    {
      field: "quantity",
      name: "Số lượng",
      sortable: true,
      truncateText: true,
      width: "10%",
      render: (quantity: string, online: WarranteeSamsungSession) => (
        <Text w={"100%"} truncate>
          {quantity} - ( Success: {online.quantity_Success})
        </Text>
      ),
    },
    {
      field: "createDate",
      name: "Thời gian",
      sortable: true,
      truncateText: true,
      width: "10%",
      render: (date: string) => (
        <Text w={"100%"} truncate>
          {date}
        </Text>
      ),
    },
    {
      field: "",
      name: "Xem chi tiết",
      sortable: true,
      truncateText: true,
      width: "7%",
      render: (online: WarranteeSamsungSession) => (
        <EuiLink
          target="_blank"
          onClick={(e: any) => {
            navigate("/warranteeSamsung", { state: { id: online.id } });
          }}
        >
          Xem chi tiết
        </EuiLink>
      ),
    },
    {
      field: "",
      name: "Gửi đi",
      sortable: true,
      truncateText: true,
      width: "7%",
      render: (online: WarranteeSamsungSession) => (
        <>
          {online.status === "N" ? (
            <EuiLink
              target="_blank"
              onClick={(e: any) => {
                handleExcuteJob(online.id);
              }}
            >
              <EuiHealth color={getStatusColor(online.status)}>
                Gửi đi
              </EuiHealth>
            </EuiLink>
          ) : online.status === "R" ? (
            <EuiLink target="_blank">
              <EuiHealth color={getStatusColor(online.status)}>
                Đang gửi
              </EuiHealth>{" "}
            </EuiLink>
          ) : online.status === "S" ? (
            (online?.quantity_Success || 0) < (online?.quantity || 0) ? (
              <EuiLink
                target="_blank"
                onClick={(e: any) => {
                  handleExcuteJob(online.id);
                }}
              >
                <EuiHealth color={"yellow"}>Gửi lại</EuiHealth>
              </EuiLink>
            ) : (
              <EuiHealth color={getStatusColor(online.status)}>
                Đã gửi
              </EuiHealth>
            )
          ) : null}
        </>
      ),
    },
    {
      name: "Actions",
      width: "5%",
      render: (online: WarranteeSamsungSession) => {
        return (
          <>
            <EuiFlexGroup
              responsive={true}
              wrap={false}
              gutterSize="s"
              alignItems="center"
            >
              <EuiFlexItem grow={false}>
                <EuiButtonIcon
                  iconType="documentEdit"
                  aria-label="Dashboard"
                  color="success"
                  onClick={(e: any) => {
                    if (isNullOrUndefined(online))
                      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
                    else {
                      editItem(online.id);
                    }
                  }}
                />
              </EuiFlexItem>
              <EuiFlexItem grow={false}>
                <EuiButtonIcon
                  iconType="trash"
                  color="danger"
                  onClick={(e: any) => {
                    if (isNullOrUndefined(online))
                      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
                    else {
                      deleteItem([online.id]);
                    }
                  }}
                />
              </EuiFlexItem>
            </EuiFlexGroup>
          </>
        );
      },
    },
  ];

  const getStatusColor = (status: any) => {
    switch (status) {
      case "N":
        return "red";
      case "S":
        return "green";
      case "R":
        return "yellow";
      default:
        return "subdued";
    }
  };

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();
  const [pagination, setPagination] = useState<Pagination>(paginationBase);
  const [selectedOptions, setSelected] = useState();
  const [selectedSearch, setSelectedSearch] = useState<{
    isActive: any[];
    status: any[];
  }>({
    isActive: [],
    status: [],
  });
  const [paramSearch, setParamSearch] = useState<ParamSearchBase>();
  const [isSelectedItem, setSelectedItems] = useState<any[]>([]);
  const [datas, setDatas] = useState<WarranteeSamsungSession[]>([]);
  const [total, setTotal] = useState(0);

  const handleEditData = async (id: number) => {
    if (id) {
      editItem(id);
    } else {
      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
    }
  };

  const onTableChange = async ({
    page: { index, size },
  }: CriteriaWithPagination<any>) => {
    setPagination({
      ...pagination,
      pageIndex: index,
      pageSize: size,
      totalItemCount: 1000,
    });
  };

  const onChange = (selectedOptions: any) => {
    setSelected(selectedOptions);
    if (!isNullOrUndefinedArry(selectedOptions)) {
      const value = selectedOptions[0].value;
      if (!isNullOrUndefined(value))
        setParamSearch({ ...paramSearch, inActive: value });
    } else setParamSearch({ ...paramSearch, inActive: undefined });
  };

  const onChangeText = (event: React.ChangeEvent<HTMLInputElement>) => {
    const key = event.target.value;
    if (!isNullOrUndefined(key))
      setParamSearch({ ...paramSearch, keyWord: key });
  };

  const handleChangeSearch = (value: any[], key: string) => {
    setSelectedSearch((prevData) => ({ ...prevData, [key]: value }));
  };

  const onSelectionChange = (selectedItems: any[]) => {
    setSelectedItems(selectedItems);
  };
  const selection: EuiTableSelectionType<any> = {
    selectable: (user: any) => true,
    selectableMessage: (selectable: boolean) =>
      !selectable ? "User is currently offline" : "",
    onSelectionChange,
  };

  const handleExcuteJob = async (id: number) => {
    await excuteWarranteeSamsungSession(`?Id=${id}`);
    fetchDataWarranteeSamsungSession(
      pagination.pageIndex,
      pagination.pageSize,
      paramSearch?.keyWord,
      paramSearch?.inActive
    );
  };

  const openModal = () =>
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>Thêm mới phiên</Title>
          </div>
        </>
      ),
      children: (
        <CreateView
          onSearch={() =>
            fetchDataWarranteeSamsungSession(
              pagination.pageIndex,
              pagination.pageSize,
              paramSearch?.keyWord,
              paramSearch?.inActive
            )
          }
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });

  const openModalEdit = () => {
    if (
      isSelectedItem &&
      (isSelectedItem.length < 1 || isSelectedItem.length > 1)
    )
      NotificationExtension.Warn("Xin vui lòng chọn 1 đơn để chỉnh sửa !");
    else {
      editItem(isSelectedItem[0].id);
    }
  };

  const openModalDelete = () => {
    if (isSelectedItem && isSelectedItem.length < 1)
      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
    else {
      const ids = isSelectedItem;
      deleteItem(ids.map((item) => item?.id));
    }
  };

  function deleteItem(idItem: number[]) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xóa phiên</Title>
        </>
      ),
      children: (
        <DeleteView
          onSearch={() =>
            fetchDataWarranteeSamsungSession(
              pagination.pageIndex,
              pagination.pageSize,
              paramSearch?.keyWord,
              paramSearch?.inActive
            )
          }
          idItem={idItem}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function editItem(id: number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chỉnh sửa phiên!</Title>
        </>
      ),
      children: (
        <EditView
          id={id}
          onSearch={() =>
            fetchDataWarranteeSamsungSession(
              pagination.pageIndex,
              pagination.pageSize,
              paramSearch?.keyWord,
              paramSearch?.inActive
            )
          }
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  const elementSearch = [
    <Menu.Item closeMenuOnClick={false}>
      <EuiFormRow label="Chọn tình trạng ">
        <EuiComboBox
          aria-label="Accessible screen reader label"
          placeholder="Chọn..."
          options={optionSearch.status}
          selectedOptions={selectedSearch?.status}
          onChange={(e) => handleChangeSearch(e, "status")}
          fullWidth={true}
          singleSelection={{ asPlainText: true }}
          isDisabled={loading}
          isCaseSensitive
        />
      </EuiFormRow>
    </Menu.Item>,
  ];

  const fetchDataWarranteeSamsungSession = async (
    index: number,
    size?: number,
    keyWord?: string,
    inActive?: boolean
  ) => {
    setLoading(true);

    setError(undefined);
    const repository = new Repository(
      process.env.REACT_APP_Auth_APP_API_CUST_PRIVIEGE
    );
    try {
      let urlSearch = `${API_ROUTE.GET_LIST_WARRANTEE_SAMSUNG_SESSION}?Skip=${
        index * (size ?? 0)
      }&Take=${size}`;
      if (!isNullOrEmpty(keyWord))
        urlSearch = urlSearch + `&KeySearch=` + keyWord;
      // if (!isNullOrUndefined(inActive))
      //   urlSearch = urlSearch + `&Active=` + inActive;
      // if (
      //   selectedSearch &&
      //   selectedSearch.status &&
      //   selectedSearch.status.length > 0
      // ) {
      //   selectedSearch.status.map(
      //     (status) => (urlSearch += `&Status=${status.value}`)
      //   );
      // }

      let callapi = await repository.get<MessageResponse<any[]>>(urlSearch);
      if (isNullOrUndefined(callapi) || isNullOrUndefinedArry(callapi?.data)) {
        setTotal(0);
        setDatas([]);
      } else {
        setDatas(callapi?.data ?? []);
        setPagination({
          ...pagination,
          totalItemCount: callapi?.totalCount ?? 0,
        });
        setTotal(callapi?.totalCount ?? 0);
      }
      return callapi?.data;
    } catch (error: any) {
      setError("Có lỗi xảy ra khi tải dữ liệu !");
      return null;
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <AppAction
        openModal={openModal}
        openModalDelete={openModalDelete}
        openModalEdit={openModalEdit}
      ></AppAction>
      <Divider my="sm" />
      <AppSearch
        loading={loading}
        onChange={onChange}
        onChangeText={onChangeText}
        onSearch={() =>
          fetchDataWarranteeSamsungSession(
            pagination.pageIndex,
            pagination.pageSize,
            paramSearch?.keyWord,
            paramSearch?.inActive
          )
        }
        elementSearch={elementSearch}
      />
      <EuiSpacer size="l" />
      <EuiBasicTable
        tableCaption="Demo of EuiDataGrid with selection"
        items={datas ? datas : []}
        itemId="id"
        error={error}
        loading={loading}
        noItemsMessage={"Không có dữ liệu"}
        selection={selection}
        columns={columns}
        pagination={pagination}
        isSelectable={true}
        hasActions={true}
        responsive={true}
        onChange={onTableChange}
        compressed={true}
      />
    </>
  );
};

export default WarranteeSamsungSessionList;
